import { Record } from 'immutable';
import Util from '../util';
import { METHOD_TEXTS, TRAVEL_EXPENSES_TEXTS, IDENTITY_DISCLOSURE_TEXTS, CERTIFICATE_PRESENTATION_TEXTS, ORIGIN_RIGHT_TEXTS } from '../consts';

export type ApiDonorRequest = {
  methods: string[];
  gratuity: number;
  travel_expenses: string;
  identity_disclosure: string;
  certificate_presentation: string;
  origin_right: string;
};

const DonorRequestBase = Record({
  methods: [] as string[],
  gratuity: 0,
  travelExpenses: "",
  identityDisclosure: "",
  certificatePresentation: "",
  originRight: "",
});

export class DonorRequest extends DonorRequestBase {
  constructor(apiDonorRequest?: ApiDonorRequest) {
    super({
      methods: apiDonorRequest?.methods,
      gratuity: apiDonorRequest?.gratuity,
      travelExpenses: apiDonorRequest?.travel_expenses,
      identityDisclosure: apiDonorRequest?.identity_disclosure,
      certificatePresentation: apiDonorRequest?.certificate_presentation,
      originRight: apiDonorRequest?.origin_right,
    })
  }

  readonly methodsText: string[] = this.methods.map(v => METHOD_TEXTS[v]);

  readonly gratuityText: string = Util.thousandSeparate(this.gratuity);

  readonly travelExpensesText: string = TRAVEL_EXPENSES_TEXTS[this.travelExpenses];

  readonly identityDisclosureText: string = IDENTITY_DISCLOSURE_TEXTS[this.identityDisclosure];

  readonly certificatePresentationText: string = CERTIFICATE_PRESENTATION_TEXTS[this.certificatePresentation];

  readonly originRightText: string = ORIGIN_RIGHT_TEXTS[this.originRight];
}
